<template lang='pug'>
  r-form(
    ref='form'
    reset-text='restablecer'
    submit-text='guardar'
    v-bind='formProps'
    v-model='whPack'
    @reset='submitReset'
    @submit='submitCreate'
    )
    template( slot='header-actions' )
      v-btn( 
        color='secondary' 
        style='margin: -8px 6px;'
        @click='submitInternalCode'
        ) codigo interno &nbsp;
        v-icon refresh
      v-btn( 
        color='secondary' 
        style='margin: -8px 6px;' 
        @click='submitUPCCode'
        ) codigo upc &nbsp;
        v-icon refresh
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm } from '@/components/reusable_components/next'
  import translatorService from '@/services/translator'
  //
  import GBranchOfficeModel from '@/models/General/GBranchOffice'
  import WhPackFields from '@/views/Warehouse/WhPack/WhPackFields'
  import WhProductModel from '@/models/Warehouse/WhProduct'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: WhPackFields.create,
          title: `crear pack`
        }
      },
    },
    data() {
      return {
        whPack: new WhProductModel({
          branch_offices: [],
          sl_offers: [],
        }),
      }
    },
    methods: {
      getGBranchOffices() {
        return GBranchOfficeModel
          .limit(-1)
          .get()
      },
      getInternalCode() {
        return WhProductModel
          .params({
            product_name: this.whPack.name,
            family_id: this.whPack.wh_family_id,
            subfamily_id: this.whPack.wh_subfamily_id,
          })
          .find('suggest_internal_code')
      },
      getUPCCode() {
        return WhProductModel
          .find('suggest_upc_code')
      },
      async getWhPack() {
        return new WhProductModel({
          branch_offices: [],
          upc_codes: [],
          wh_family_id: '',
          wh_subfamily_id: '',
        })
      },
      mapGBranchOffice(gBranchOffice) {
        //
        gBranchOffice.cost_price = 0
        gBranchOffice.sale_price = 0
        gBranchOffice.gains_margin = 0
        gBranchOffice.minimum_stock = 0
        gBranchOffice.maximum_stock = 0
        gBranchOffice.critical_stock = 0
        gBranchOffice.default_warehouse_id = 0
        //
        return gBranchOffice
      },
      setGBranchOffices(gBranchOffices) {
        this.whPack.branch_offices = gBranchOffices.data.map(this.mapGBranchOffice)
      },
      setInternalCode(res) {
        this.whPack.internal_code = res.suggested_code
      },
      setUPCCode(res) {
        this.whPack.upc_codes.push(res.suggested_code)
      },
      setWhPack(whPack) {
        this.whPack = whPack.reset()
      },
      showError(event) {
        console.log({ event })
        this.showErrorSnackbar(translatorService(WhProductModel, event.response.data))
      },
      showUPCCodeError(error) {
        this.showErrorSnackbar('Error al generar codigo UPC.')
      },
      showInternalCodeError() {
        this.showErrorSnackbar('Error al generar codigo interno.')
      },
      showCreateSuccess() {
        this.showSuccessSnackbar('Pack creado exitosamente.')
      },
      showUPCCodeSuccess() {
        this.showSuccessSnackbar('Codigo UPC agregado exitosamente.')
      },
      showInternalCodeSuccess() {
        this.showSuccessSnackbar('Codigo interno agregado exitosamente.')
      },
      submitReset() {
        this.getWhPack().then(this.setWhPack)
        this.getGBranchOffices().then(this.setGBranchOffices)
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showError)
          .then(this.toWait)
      },
      submitInternalCode() {
        return this
          .toWait(true)
          .then(this.getInternalCode)
          .then(this.setInternalCode)
          .then(this.showInternalCodeSuccess)
          .catch(this.showInternalCodeError)
          .then(this.toWait)
      },
      submitUPCCode() {
        return this
          .toWait(true)
          .then(this.getUPCCode)
          .then(this.setUPCCode)
          .then(this.showUPCCodeSuccess)
          .catch(this.showUPCCodeError)
          .then(this.toWait)
      },
      toCreate() {
        return this
          .whPack
          .toPack()
          .toCreate()
          .save()
      },
      toRedirect() {
        this.$router.push({ name: 'wh-pack-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Crear pack')
    },
    mounted() {
      this.submitReset()
    }
  }
</script>